"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));
var _Button = _interopRequireDefault(require("../Button"));
var _reactI18next = require("react-i18next");
var _default = exports["default"] = function _default(_ref) {
  var isOpen = _ref.isOpen,
    email = _ref.email,
    toggle = _ref.toggle,
    onGoToSettings = _ref.onGoToSettings;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    disableBackdropClick: true,
    disableEscapeKeyDown: true,
    open: isOpen,
    onClose: toggle,
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], null, t('customDomainAliasNotReadyDialog.title', {
    emailAddress: email
  })), /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-gray-light"
  }, t('customDomainAliasNotReadyDialog.content'))), /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: toggle,
    color: "secondary",
    size: "sm",
    style: {
      width: '9rem'
    }
  }, t('button.okay')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: function onClick() {
      onGoToSettings();
      toggle();
    },
    color: "primary",
    size: "sm",
    style: {
      width: '9rem'
    }
  }, t('button.goToSettings'))));
};
//# sourceMappingURL=index.js.map